import React,{useContext, useState} from 'react'
import { VfContext } from './VfContext';

import { MEDIA } from '../config/general';

const Question = ({ question, order, vfClick, right, answers, ilustraL, ilustraR, index, next }) => {
  const [answered, setAnswered] = useState(false);
  const [thisAnswer, setThisAnswer] = useState();
  const { size,
          cantidadPreguntas,
          constestadas,
          siguienteButton,
          correctoTexto,
          incorrectoTexto
         } = useContext(VfContext);

  const answerQuestion = (answer_index) =>{
    // envia la respuesta al parent
    vfClick(index, answer_index);
    // y la setea en el componente para que quede respondido
    setThisAnswer(answer_index);
    setAnswered(true);
  }
      
  const pageSize = {
    height: `${size[1]}px`,
    
  }

  const ilustraRight = {
    backgroundImage: `url(${MEDIA + ilustraR})`,
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    backgroundPositionX: '100%',
    backgroundPositionY: '100%',
    right: '4vw'
  }

  const ilustraLeft = {
    backgroundImage: `url(${MEDIA + ilustraL})`,
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    backgroundPositionX: '0%',
    backgroundPositionY: '100%',
    left: '4vw'
  }


  const displayQuestion = () => {
    return(
      <div className='question-page' style={ pageSize }>
      <div className='char' style={ ilustraRight }></div>
      <div className='char' style={ ilustraLeft }></div>
      <div className='question-container'>
        <p className='question'>{ `${order}. ${question}` }</p>
        <span className="espacio-respuesta">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        <div className='btn-container'>
            { answers.map((answer, index) => (
              <button key={ index } className='btn-option' onClick={ () => answerQuestion(index) }> { answer } </button>
            )) }
        </div>
      </div>
    </div>
    );
  }

  const displayAnswer = () => {
    return (
      <div className='answer-page' style={ pageSize }>
        <div className='char' style={ ilustraRight }></div>
        <div className='char' style={ ilustraLeft }></div>
          <div className='question-container'>
          <p className='question'>{ `${order}. ${question}` }</p>
          <span className="espacio-respuesta"> { answers[thisAnswer] } &nbsp;</span>
          </div>
          <div className='answer-info'>
            <p className={ right === thisAnswer ? 'right correcto' : 'right incorrecto' }>{ right === thisAnswer ? correctoTexto : incorrectoTexto }</p>
            { right !== thisAnswer ? <p className='answer'>{ `${correctoTexto}: ${answers[right]}` }</p> : '' }
            <div className='btn-container'>
              { (index + 1 === cantidadPreguntas && cantidadPreguntas === constestadas) || index + 1 !== cantidadPreguntas  ? <button onClick={ next }>{ siguienteButton }</button> : <div className="next-button-holder"></div> }
            </div>
          </div>
      </div>
    )
  }

  return (
    answered ? displayAnswer() : displayQuestion()
  )
}

export default Question